<!-- 个人中心 - 父组件 -->
<template>
  <div class="personal_container">
    <div class="personal">

      <!-- Side Nav -->
      <nav class="personal_nav" :class="{'personal_nav_close': !$store.state.sideNavOpen}">
        <div class="personal_nav_switch">
          <img src="../../assets/images/personal/collapse_icon.png" @click="changeSideNavStatus('close')" v-if='$store.state.sideNavOpen'>
          <img src="../../assets/images/personal/collapse_icon_horizon.png" @click="changeSideNavStatus('open')" v-else> 
        </div>
        <div class="personal_nav_pos side_nav_con_pos" :class="{'triangle_icon': $store.state.sideNavOpen}">
            <img src='../../assets/images/personal/personal.png'>
            <span v-show="$store.state.sideNavOpen">个人中心</span>
        </div>
        <ul class="personal_nav_con">
          <li class="personal_nav_item side_nav_con_pos" :class="{'side_nav_selected': nav.selected}" v-for="nav in navs" @click="changeItem(nav.link)">
            <img :src="'../../assets/images/personal/' + nav.name + '_s.png'" v-if="nav.selected">
            <img :src="'../../assets/images/personal/' + nav.name + '.png'" v-else>
            <span v-show="$store.state.sideNavOpen">{{nav.title}}</span>
          </li>
        </ul>
      </nav>

      <!-- Content -->
      <div class="personal_content">
        <div class="personal_content_box">
          <div class="personal_content_scroll_wrap">
            <!-- <router-view @childChange="changeTab"></router-view> -->
            <router-view></router-view>
          </div>
        </div>
      </div>

      <!-- <account-info></account-info>  -->
      <!-- <show-remain-sum></show-remain-sum> -->
      <!-- <loading v-if="$store.state.isLoadingPersonal"></loading> -->
      <loading v-if="$store.state.isLoadingPersonal"></loading>
    </div>
  </div>
</template>


<script>

  import Loading from '../common/LoadingPersonal'

  export default {
    name: 'PersonalCenterContainer',
    components: {Loading},
    data () {
      return {
        picRootPath: '/assets/images/personal/',
        navs: [{
            title: '基本信息',
            name: 'account_info',
            selected: false,
            link: '/account_info'
          },{
            title: '我的存证',
            name: 'my_evidences',
            selected: false,
            link: '/my_evidences'
          },{
            title: '我的钱包',
            name: 'account_balance',
            selected: false,
            link: '/account_balance'
          },{
            title: '操作记录',
            name: 'trash',
            selected: false,
            link: '/trash'
        }],
        triangleStatus: this.$store.state.sideNavOpen
      }
    },
    created () {
      this.$store.commit('setCurrentHeader', 'personal');
      this.$store.commit('showContentFooter', false);
      this.navStatusInit();
    },
    mounted (){
        $('html, body, #app').css({
          'height':'100%',
          'overflow': 'hidden'
        })

        this.navs.forEach(item=>{
          item.picLink = this.picRootPath + item.name + '.png'
        })
    },
    destroyed (){
        $('html, body, #app').css({
          'height':'auto',
          'overflow': 'auto'
        })
        this.$store.commit('showLoadingPersonal', false)
    },
    methods: {
      navStatusInit () {
        let path = this.$router.history.current.fullPath
        this.navs.forEach( item => {
          item.selected = false;
          if (path.indexOf(item.name) != -1) {
            item.selected = true;
          }
        })
      },
      changeSideNavStatus (status) {
        // this.sideNavOpen = status == 'close' ? false : true;
        status == 'close' ? this.$store.commit('sideNavOpen', false) : this.$store.commit('sideNavOpen', true)
      },
      changeItem (item) {
        this.$router.push('/personal_center'+item);
        // $(window).scrollTop(()=>{
        //     $('body,html').animate({ scrollTop: 0 });
        // });
      },
      changeTab (link) {
        this.navs.forEach(nav=>{
           nav.selected = false;
           if(nav.link == link){
              nav.selected = true;
           }
        });
      }
    },
    watch: {
      '$route' (to, from) {
          this.navStatusInit()
      }
    }
  }
</script>

<style scoped>
  .personal_container{
    width: 100%;
    height: 100%;
    padding-top: 62px;
  }
  .personal{
    width: 100%;
    height: 100%;
    overflow: hidden;
  }


  .personal_nav{
    width: 150px;
    float: left;
    height: 100%;
    transition: all 0.5s;
    background-color: #2d343e;
    overflow: hidden;
  }
  .personal_nav_close{
    width: 50px;
    transition: all 0.5s;
  }
  .personal_nav .personal_nav_switch{
    height: 30px;
    background-color: #3d4552;
    text-align: center;
    line-height: 30px;
  }
  .personal_nav .personal_nav_switch img{
    cursor: pointer;
  }
  .personal_nav .personal_nav_pos{
    height: 50px;
    color: #e9f0f5;
    padding-top: 18px;
    border-bottom: 1px solid #080b12;
    position: relative;
  }
  .personal_nav .triangle_icon:after, .personal_nav .triangle_icon:before {
    border: 5px solid transparent;
    content: ' ';
    height: 0;
    left: 71px;
    position: absolute;
    width: 0;
    top: 49px;
    z-index: 999;
  }
  .personal_nav .triangle_icon:after {
    border-top: 8px solid #2e343e;
  }
  .personal_nav .triangle_icon:before {
    border-top: 10px solid #000;
  }

  .personal_nav .personal_nav_con{
    width: 100%;
  }
  .personal_nav .personal_nav_item{
    height: 46px;
    width: 100%;
    color: #9499a6;
    padding-top: 15px;
    cursor: pointer;
    overflow: hidden;
    position: relative;
  }
  .personal_nav .side_nav_con_pos img{
    float: left;
    margin: 0 18px;
  }
  .personal_nav .side_nav_con_pos span{
    position: absolute;
    /*float: left;*/
    line-height: 18px;
    left: 52px;
    width: 60px;
  }
  .personal_nav .side_nav_selected{
    background: #b34552;
    color: #fff;
  }


  .personal_content{
    height: 100%;
    background-color: #f7f7f7;
    overflow: hidden;
  }
  .personal_content .personal_content_box {
    overflow-y: auto;
    height: 100%;
    padding: 10px;
  }
  .personal_content_scroll_wrap{
    min-height: 200px;
    background: #fff;
    border: 1px solid #e4e4e4;
  }
</style>



// WEBPACK FOOTER //
// PersonalCenter.vue?ca6019e8